import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Layout.module.css';

const Layout = ({ children }) => {
  const currentUser = useSelector(state => state.session.currentUser);
  const isLoggedIn = !!currentUser;

  const mainCssClasses = classNames(
    styles['main-container'],
    isLoggedIn && styles['with-sidebar']
  );

  return (
    <>
      {isLoggedIn ? <Sidebar /> : null}

      <main className={mainCssClasses}>{children}</main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
